import type { KeyTextField } from '@prismicio/client';
import { Icon } from '@/assets';

import styles from './getOfferSafety.module.scss';

interface GetOfferSafetyProps {
  text: KeyTextField;
}
export const GetOfferSafety = ({ text }: GetOfferSafetyProps) => {
  return (
    <p className={styles.safe}>
      <Icon icon="Security check" />
      {text}
    </p>
  );
};
